import React, { useEffect, useState } from "react";
import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

const AdminReviews = () => {
  const [reviews, setReviews] = useState([]);

  // Fetch all reviews (including pending)
  const fetchAllReviews = async () => {
    try {
      const response = await axios.get(
        `${BACKEND_URL}/api/testimonials?approved_only=false`
      );
      setReviews(response.data);
    } catch (error) {
      console.error("Error fetching reviews:", error);
    }
  };

  useEffect(() => {
    fetchAllReviews();
  }, []);

  // ✅ Approve review
  const approveReview = async (id) => {
    try {
      await axios.patch(
        `${BACKEND_URL}/api/testimonials/${id}/approve`,
        {},
        {
          headers: {
            "x-admin-token": "Siarefi24",
          },
        }
      );

      fetchAllReviews();
    } catch (error) {
      console.error("Error approving review:", error);
    }
  };

  // ✅ Delete review
  const deleteReview = async (id) => {
    try {
      await axios.delete(
        `${BACKEND_URL}/api/testimonials/${id}`,
        {
          headers: {
            "x-admin-token": "Siarefi24",
          },
        }
      );

      fetchAllReviews();
    } catch (error) {
      console.error("Error deleting review:", error);
    }
  };

  return (
    <div style={{ padding: "60px 20px", maxWidth: "900px", margin: "0 auto" }}>
      <h1 style={{ fontSize: "32px", marginBottom: "30px" }}>
        Admin - Review Management
      </h1>

      {reviews.length === 0 ? (
        <p>No reviews found.</p>
      ) : (
        reviews.map((review) => (
          <div
            key={review.id}
            style={{
              background: "#f5f5f5",
              padding: "20px",
              borderRadius: "10px",
              marginBottom: "20px",
            }}
          >
            <h3>
              {review.name} - {review.rating}⭐
            </h3>

            <p>
              <strong>Location:</strong> {review.role}
            </p>

            <p>{review.text}</p>

            <p>
              <strong>Status:</strong>{" "}
              {review.approved ? "Approved" : "Pending"}
            </p>

            <div style={{ marginTop: "10px" }}>
              {!review.approved && (
                <button
                  onClick={() => approveReview(review.id)}
                  style={{
                    background: "green",
                    color: "white",
                    padding: "8px 15px",
                    marginRight: "10px",
                    border: "none",
                    borderRadius: "5px",
                    cursor: "pointer",
                  }}
                >
                  Approve
                </button>
              )}

              <button
                onClick={() => deleteReview(review.id)}
                style={{
                  background: "red",
                  color: "white",
                  padding: "8px 15px",
                  border: "none",
                  borderRadius: "5px",
                  cursor: "pointer",
                }}
              >
                Delete
              </button>
            </div>
          </div>
        ))
      )}
    </div>
  );
};

export default AdminReviews;
